
/*
 * BUILD @athena/forge v9.0.0
 * THIS IS AN AUTOGENERATED FILE
 */

import React from 'react';
import IconBase from '../_IconBase';
const Help = props => {
  const modClassName = props.className;

  return (
    <IconBase viewBox="0 0 25 25" {...props} className={ modClassName }>
      <g>
        <g className="fe_c_icon__background">
          <rect width="25" height="25"></rect>
        </g>
        <g className="fe_c_icon__icon fe_c_icon__icon--primary">
          <g>
            <path d="M13.2,10.2c0-.6-.4-.9-1-.9a3.9,3.9,0,0,0-2.1,1.1,2,2,0,0,0-.5.5v-2a2.91,2.91,0,0,1,1.3-1,4.19,4.19,0,0,1,1.6-.4c1.6,0,2.8.8,2.8,2.6s-2.2,2.4-2.1,4.2H11.3C11,12.1,13.2,11.3,13.2,10.2Zm-2,6.3a1.1,1.1,0,1,1,1.1,1.1A1.11,1.11,0,0,1,11.2,16.5Z"></path>
            <path d="M20,5a11,11,0,0,0-7.5-3.1A11,11,0,0,0,5,5,10.7,10.7,0,0,0,5,20a11,11,0,0,0,7.5,3.1A11,11,0,0,0,20,20,10.7,10.7,0,0,0,20,5ZM18.9,18.9a9.1,9.1,0,0,1-6.4,2.7,9.1,9.1,0,0,1,0-18.2,9.1,9.1,0,0,1,6.4,15.5Z"></path>
          </g>
        </g>
      </g>
    </IconBase>);
};

Help.defaultProps = {
  title: 'Help',
};

export default Help;
